'use client';

import { useSubscriptionHistory } from '@wwe-portal/web/utils/club-store/helper';
import {
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { ReferSubscriptionDialog as ReferSubscriptionDialogUI } from '../../../../../../packages/ui/features/club-store';

export const ReferSubscriptionDialog = createPortableDialog(
  ({ description }: { description: React.ReactNode }) => {
    const modal = usePortableDialog();
    const { goToSubscription } = useSubscriptionHistory();
    return (
      <ReferSubscriptionDialogUI
        open={modal.visible}
        onClose={modal.remove}
        description={description}
        onChange={() => {
          goToSubscription();
          modal.remove();
        }}
      />
    );
  }
);
